import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { uniq } from 'ramda';
import { useNavigate } from 'react-router-dom';

// store
import { storeGet, storeSet } from '../../../../store';

// api
import CompanyDocumentsService from '../../../../service/company-documents-service';

// tools
import set404FromErrorResponse from '../../../../helpers/set404FromErrorResponse';
import translationStrings from '../../../../translationStringsForComponents';

// components
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import ProperBandoLabel from '../../../../components/ProperBandoLabel';
import { ProgressBar } from 'primereact/progressbar';


const ListCompaniesTable = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState(null);
    const [loading, setLoading] = useState(false);
    const [, setStatuses] = useState([]);

    useEffect(() => {
        setLoading(true);

        const userData = storeGet('userData');
        CompanyDocumentsService.getCompanyDocumentsGrouped(getCallback, errGetCallbacks, [
            ["userId", userData.id]
        ]);
    }, []);

    const getCallback = (data) => {
        if (data.status === 'SUCCESS') {
            const { totalActiveCall, companyDocument } = data.data;
            setItems(getFormattedData(companyDocument));
            setStatuses(uniq(companyDocument.map(o => o.status)))
            initFilters();
        }
        setLoading(false);
    }

    const errGetCallbacks = (data) => {
        set404FromErrorResponse(data);
        setLoading(false);
    }

    const getFormattedData = (data) => {
        return [...(data || [])].map((d) => {
            d.uploadedDate = new Date(d.uploadedDate);

            return d;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            companyName: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            uploadedDate: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
            },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
        });
    };

    const renderHeader = () => {
        return (
            <div className="appTableHeader">
                <Button type="button" icon="pi pi-filter-slash" label={__('Pulisci', 'htr')} outlined
                        onClick={clearFilter}/>
            </div>
        );
    };

    const dateStartBodyTemplate = (rowData) => {
        return formatDate(rowData.uploadedDate);
    };

    const progressTemplate = (rowData) => {
        const progress = parseFloat((rowData.documentRecieved/rowData.totalRequiredDocument)*100);
        return <ProgressBar
            value={progress.toFixed(0)}
            style={{ height: '8px' }}
            displayValueTemplate={() => <span></span>}
            color={'#64748B'}></ProgressBar>;
    };

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)}
                         dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999"/>;
    };

    const statusBodyTemplate = (rowData) => {
        return <ProperBandoLabel status={rowData.status}/>;
    };

    const actionsBodyTemplate = (rowData) => {
        return <div className="appPageSection__tableActions">
            {!rowData.allValidDocuments
                ? <Button severity="info"
                    onClick={() => handleCompleteDocsRedirect(rowData)}
                    label={__('Completa documenti', 'htr')}
                    size="small"/> : null}
        </div>
    }

    const handleCompleteDocsRedirect = (data) => {
        storeSet('chosenCompanyId', data.companyId);
        navigate('/documenti');
    }

    const header = renderHeader();

    return (
        <div className="appPageSection__table">
            <DataTable value={items} paginator showGridlines rows={5} loading={loading} dataKey="companyId"
                       filters={filters} stripedRows removableSort
                       header={header}
                       emptyMessage={translationStrings.emptyMessage}
                       onFilter={(e) => setFilters(e.filters)}>
                <Column field="companyName" header={__('Azienda', 'htr')}
                        filter sortable
                        filterPlaceholder={__('Cerca il nome', 'htr')}
                        style={{ minWidth: '8rem' }}/>
                <Column header={__('Ultima Modifica', 'htr')} filterField="uploadedDate" dataType="date"
                        style={{ minWidth: '8rem' }}
                        body={dateStartBodyTemplate} filter filterElement={dateFilterTemplate}/>
                <Column header={__('Progressi', 'htr')}
                        style={{ minWidth: '8rem' }}
                        body={progressTemplate}/>
                <Column field="status" header={__('Stato', 'htr')}
                        style={{ minWidth: '7rem' }} body={statusBodyTemplate} />
                <Column header={__('Azioni', 'htr')}
                        body={actionsBodyTemplate}/>
            </DataTable>
        </div>
    )
}

export default ListCompaniesTable;